var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallCarrot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 8.332c1.33-2.783.644-6.082-2.074-8.332-2.608 2.162-3.323 5.273-2.192 7.975-.82-.287-1.658-.475-2.49-.475a7.602 7.602 0 00-6.832 4.266L.14 28.026a1.372 1.372 0 000 1.2c.24.487.727.768 1.23.768.2 0 .405-.047.604-.14l16.266-7.94a7.582 7.582 0 003.492-3.492c.92-1.881.99-3.961.358-5.795 2.69 1.096 5.765.37 7.916-2.22-2.262-2.72-5.555-3.405-8.338-2.075zm-2.467 8.86a4.728 4.728 0 01-2.197 2.197l-3.358 1.64-1.4-1.4a1.406 1.406 0 00-1.986 1.986l.714.715-6.468 3.164 5.63-11.531 1.993 2.033c.275.275.633.41.996.41s.72-.134.996-.41a1.4 1.4 0 000-1.986l-2.438-2.397c.868-.803 1.993-1.295 3.229-1.295.726 0 1.43.164 2.092.487a4.762 4.762 0 012.425 2.742 4.744 4.744 0 01-.228 3.644z",
    fill: "#91C300"
  })));
}

export default SvgSmallCarrot;